import styled from 'styled-components';
import tw from 'twin.macro';

export const SegmentedFrame = styled.div(
  /* p-2 is the gutter the active pill sits in: the track stays visible around
     it on all sides. The track needs a tint darker than whatever it sits on,
     or it disappears into its background and the segments read as loose
     labels rather than as a control */
  tw`inline-flex items-center p-2 rounded-full bg-silver-lighten-15`
);

export const Segment = styled.button<{ $active: boolean }>(({ $active }) => [
  tw`flex items-center justify-center m-0 border-0 cursor-pointer whitespace-nowrap appearance-none select-none`,
  tw`rounded-full leading-20 font-medium text-sm transition-colors duration-100`,
  /* 2px 12px: with the frame's own 2px gutter this makes 28px total height,
     the small outlined Button's height */
  tw`py-2 px-12`,
  $active
    ? [
        tw`bg-white text-black text-opacity-85`,
        /* Not a token: the one shadow token is the white one. A hairline ring
           plus a short drop lift the active pill off the track without
           reading as a second border */
        `box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.12);`
      ]
    : tw`bg-transparent text-black text-opacity-60 can-hover:hover:text-opacity-85 focus-visible:text-opacity-85`
]);

/* Below md the label gives way to the glyph, for a control that keeps its
   meaning where the toolbar has no room to spell it out. Only rendered when
   the control is asked to collapse, so the two are never both visible */
export const SegmentIcon = styled.span(tw`inline-flex items-center text-md md:hidden`);

export const SegmentLabel = styled.span<{ $collapses: boolean }>(({ $collapses }) => [
  $collapses && tw`hidden md:inline`
]);
